<template>
  <p v-if="recaptchaEnabled" class="recaptcha-notice">
    Este site é protegido pelo reCAPTCHA. Aplicam-se a
    <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">Política de Privacidade</a>
    e os
    <a href="https://policies.google.com/terms" target="_blank" rel="noopener noreferrer">Termos de Serviço</a>
    do Google.
  </p>
</template>

<script>
import { isRecaptchaEnabled } from '@/services/recaptcha'

export default {
  name: 'RecaptchaNotice',
  data() {
    return {
      recaptchaEnabled: isRecaptchaEnabled()
    }
  }
}
</script>

<style lang="scss" scoped>
.recaptcha-notice {
  margin: 1rem 0 0 0;
  font-size: 0.7rem;
  line-height: 1.4;
  text-align: center;
  opacity: 0.65;

  a {
    text-decoration: underline;
  }
}
</style>
